module.exports = __webpack_public_path__ + "img/about/80243-033.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-033.png
// module id = 33
// module chunks = 0